
import * as ipxRuntime$ZUZJoQA1vU from '/Users/jonathan.leignier/Desktop/FC&AL FILE/Retailers/Git-Dentsu-clone v2/dentsu/node_modules/.pnpm/@nuxt+image@1.9.0_db0@0.2.3_ioredis@5.4.2_magicast@0.3.5_rollup@4.34.2/node_modules/@nuxt/image/dist/runtime/providers/ipx'

export const imageOptions = {
  "screens": {
    "xs": 320,
    "sm": 640,
    "md": 768,
    "lg": 1024,
    "xl": 1280,
    "xxl": 1536,
    "2xl": 1536
  },
  "presets": {},
  "provider": "ipx",
  "domains": [],
  "alias": {},
  "densities": [
    1,
    2
  ],
  "format": [
    "webp"
  ]
}

imageOptions.providers = {
  ['ipx']: { provider: ipxRuntime$ZUZJoQA1vU, defaults: {} }
}
        